import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CardsWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(7.5),
}));
